import React, { createContext, useContext } from 'react';

const AppContext = createContext(null);

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

export const AppProvider = ({ children, value }) => {
  // Only provide user info, userType, users, and any helper functions for API calls
  const contextValue = {
    ...value,
    handleLogout: value.handleLogout,
  };
  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
